import { useEffect, useState } from 'react';
import { apiFetch } from '../lib/api';
import { swr } from '../lib/dataCache';
import { NEEDS_ROW_KEYS } from '../lib/needsToday';

const unavailable = () => Object.fromEntries(NEEDS_ROW_KEYS.map((k) => [k, { new: null }]));

// The "New today" numbers for Home: one backend call (GET /api/home/needs-today). A row the server could not compute is
// null and the page shows "–"; if the call itself fails every row is null. Never a made-up 0. Only a COMPLETE answer is
// remembered in memory (lib/dataCache.js), so a failed read is never shown again from memory.
export function useNeedsToday(orgId, enabled = true) {
  const [state, setState] = useState({ loaded: false, rows: unavailable() });
  useEffect(() => {
    if (!enabled) return undefined;                  // an agent Home has the Today tile instead and never asks for these rows
    let cancelled = false;
    swr({
      orgId,
      name: 'needs-today',
      onData: (value) => { if (!cancelled) setState({ loaded: true, rows: value.rows }); },
      load: async () => {
        try {
          const res = await apiFetch('/api/home/needs-today');
          const json = await res.json();
          if (!res.ok || !json || !json.ok || !json.rows) throw new Error('needs-today');
          const rows = { ...unavailable(), ...json.rows };
          return { value: { rows }, cacheable: NEEDS_ROW_KEYS.every((k) => rows[k] && rows[k].new != null) };
        } catch {
          return { value: { rows: unavailable() }, cacheable: false };
        }
      },
    });
    return () => { cancelled = true; };
  }, [orgId, enabled]);
  return state;
}
